import { render, staticRenderFns } from "./party-order-cancel.component.vue?vue&type=template&id=2cf7cb67"
import script from "./party-order-cancel.component.vue?vue&type=script&lang=js"
export * from "./party-order-cancel.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports